var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApigateway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8c4fff",
    d: "M0 0h64v64H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M28 44h3v-2h-3zm5 0h3v-2h-3zm-5-22h3v-2h-3zm5 0h3v-2h-3zm-11-9.26-10 5.834v27.808l10 5zM24 20h2v2h-2v20h2v2h-2v9a1 1 0 0 1-1.447.895l-12-6A1 1 0 0 1 10 47V18a1 1 0 0 1 .496-.864l12-7A1.002 1.002 0 0 1 24 11zm28-1.426L42 12.74v38.641l10-5zM54 18v29c0 .379-.214.725-.553.895l-12 6a1 1 0 0 1-.972-.044A1 1 0 0 1 40 53v-9h-2v-2h2V22h-2v-2h2v-9a.998.998 0 0 1 1.504-.864l12 7A1 1 0 0 1 54 18m-19.061 9.342-1.878-.684-4 11 1.878.684zm4.768 5.365a1 1 0 0 0 0-1.414l-3-3-1.414 1.414L37.586 32l-2.293 2.293 1.414 1.414zm-12.414 3-3-3a1 1 0 0 1 0-1.414l3-3 1.414 1.414L26.414 32l2.293 2.293z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApigateway);
export default __webpack_public_path__ + "static/media/apigateway.57021a728d8145161d970593d9f672c2.svg";
export { ForwardRef as ReactComponent };